import styled from 'styled-components'
import { Padding } from '../..'
import { mediaQueryForBigger, mediaQuery } from '../../utils'

export const HeaderContainer = styled(Padding)`
    ${mediaQueryForBigger.mobile(`
    height: 80px;
  `)}

    ${mediaQuery.mobile(`
    height: 200px;
  `)}
`

export const TopContainer = styled(Padding)`
    ${mediaQueryForBigger.mobile(`
    height: 50%;
  `)}
`

export const MiddleContainer = styled(Padding)`
    margin: 0 auto;
    ${mediaQueryForBigger.mobile(`
    height: 30vh;
    max-height: 210px;
    display: -webkit-flex;
  `)}
`

export const BottomContainer = styled(Padding)`
    ${mediaQueryForBigger.mobile(`
  min-height: 40vh;
  `)}
`
